import AuditLogPage from '@containers/auditLog/AuditLogPage';
import CondoManagementPage from '@containers/condo/CondoManagementPage';
import CreateAgentPage from '@containers/agent/CreateAgentPage';
import CreateListingsPage from '@containers/listing/CreateListingsPage';
import CreateOfficePageOG from '@containers/office/CreateOfficePageOG';
import EditAgentPage from '@containers/agent/EditAgentPage';
import EditOfficePageOG from '@containers/office/EditOfficePageOG';
import Dashboard from '@containers/dashboard/Dashboard';
import RowLockPage from '@components/rowLock/RowLockPage';
import SearchAgentPage from '@containers/agent/SearchAgentPage';
import SearchListingsPage from '@containers/listing/SearchListingsPage';
import SearchOfficePage from '@containers/office/SearchOfficePage';
import ViewAgentPage from '@containers/agent/ViewAgentPage';
import ViewListingPage from '@containers/listing/ViewListingsPage';
import ViewOfficePage from '@containers/office/ViewOfficePage';
import Matrix from '@containers/vendorApps/matrix/Matrix';
import REMapList from '@containers/vendorApps/remaplist/REMapList';
import CREAWEBForms from '@containers/vendorApps/crea/CREAWEBForms';
import CREADDF from '@containers/vendorApps/crea/CREADDF';
import Prospects from '@containers/vendorApps/prospects/Prospects';
import Spin from '@containers/vendorApps/spin/Spin';
import Spacelist from '@containers/vendorApps/spacelist/SpaceList';
import CloudCMA from '@containers/vendorApps/cloudcma/CloudCMA';
import RECA from '@containers/resources/RECA';
import PostalCodeLookup from '@containers/resources/PostalCodeLookup';
import Training from '@containers/resources/Training';

export default [
  {
    id: 'dashboard_page',
    path: '/',
    breadcrumbPath: '/',
    name: 'Home',
    Component: Dashboard,
  },
  {
    id: 'create_agent_page',
    path: '/agent/create',
    breadcrumbPath: '/agent/create',
    name: 'Create Agent',
    Component: CreateAgentPage,
  },
  {
    id: 'edit_agent_page',
    path: '/agent/edit',
    breadcrumbPath: '/agent/edit',
    name: 'Edit Agent',
    Component: EditAgentPage,
  },
  {
    id: 'search_agent_page',
    path: '/agent/search',
    breadcrumbPath: '/agent/search',
    name: 'Search Agents',
    Component: SearchAgentPage,
  },
  {
    id: 'view_agent_page',
    path: '/agent/view',
    breadcrumbPath: '/agent/view',
    name: 'View Agent',
    Component: ViewAgentPage,
  },
  {
    id: 'audit_log_page',
    path: '/audit',
    breadcrumbPath: '/audit',
    name: 'Audit Log',
    Component: AuditLogPage,
  },
  {
    id: 'condo_management_page',
    path: '/condo',
    breadcrumbPath: '/condo',
    name: 'Condo Management',
    Component: CondoManagementPage,
  },
  {
    id: 'create_listings_page',
    path: '/listings/create/:listingType',
    breadcrumbPath: '/listings/create',
    name: 'Create Listing',
    Component: CreateListingsPage,
  },
  {
    id: 'edit_listings_page',
    path: '/listings/edit/:listingType',
    breadcrumbPath: '/listings/edit',
    name: 'Edit Listing',
    Component: CreateListingsPage,
  },
  {
    id: 'search_listings_page',
    path: '/listings/search',
    breadcrumbPath: '/listings/search',
    name: 'Search Listings',
    Component: SearchListingsPage,
  },
  {
    id: 'view_listings_page',
    path: '/listings/view',
    breadcrumbPath: '/listings/view',
    name: 'View Listing',
    Component: ViewListingPage,
  },
  {
    id: 'search_office_page',
    path: '/office/search',
    breadcrumbPath: '/office/search',
    name: 'Search Office',
    Component: SearchOfficePage,
  },
  {
    id: 'create_office_page',
    path: '/office/create',
    breadcrumbPath: '/office/create',
    name: 'Create Office',
    Component: CreateOfficePageOG,
  },
  {
    id: 'edit_office_page',
    path: '/office/edit',
    breadcrumbPath: '/office/edit',
    name: 'Edit Office',
    Component: EditOfficePageOG,
  },
  {
    id: 'view_office_page',
    path: '/office/view',
    breadcrumbPath: '/office/view',
    name: 'View Office',
    Component: ViewOfficePage,
  },
  {
    id: 'row_lock_page',
    path: '/rowLock/:entityType/:entityId',
    breadcrumbPath: '/rowLock',
    name: 'Row Lock',
    Component: RowLockPage,
  },
  {
    id: 'matrix_page',
    path: '/matrix',
    breadcrumbPath: '/matrix',
    name: 'Matrix',
    Component: Matrix,
  },
  {
    id: 'remaplist_page',
    path: '/remaplist',
    breadcrumbPath: '/remaplist',
    name: 'REMapList',
    Component: REMapList,
  },
  {
    id: 'creawebforms_page',
    path: '/crea/webforms',
    breadcrumbPath: '/crea/webforms',
    name: 'CREA WEBForms',
    Component: CREAWEBForms,
  },
  {
    id: 'creaddf_page',
    path: '/crea/ddf',
    breadcrumbPath: '/crea/ddf',
    name: 'CREA DDF',
    Component: CREADDF,
  },
  {
    id: 'prospects_page',
    path: '/prospects',
    breadcrumbPath: '/prospects',
    name: 'Prospects',
    Component: Prospects,
  },
  {
    id: 'spin_page',
    path: '/spin',
    breadcrumbPath: '/spin',
    name: 'Spin2',
    Component: Spin,
  },
  {
    id: 'spacelist_page',
    path: '/spacelist',
    breadcrumbPath: '/spacelist',
    name: 'Spacelist',
    Component: Spacelist,
  },
  {
    id: 'cloudcma_page',
    path: '/cloudcma',
    breadcrumbPath: '/cloudcma',
    name: 'Cloud CMA',
    Component: CloudCMA,
  },
  {
    id: 'postalcodelookup_page',
    path: '/resources/postalcodelookup',
    breadcrumbPath: 'resources/postalcodelookup',
    name: 'Postal Code Lookup',
    Component: PostalCodeLookup,
  },
  {
    id: 'reca_page',
    path: '/resources/reca',
    breadcrumbPath: '/resources/reca',
    name: 'RECA',
    Component: RECA,
  },
  {
    id: 'training_page',
    path: '/resources/training',
    breadcrumbPath: '/training',
    name: 'Training',
    Component: Training,
  },
];
